function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IinfoCircleWhite = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    notChangeable: true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.0251 7.15166C13.0251 7.78588 12.4915 8.30332 11.8375 8.30332C11.1835 8.30332 10.65 7.78588 10.65 7.15166C10.65 6.51859 11.1782 6 11.8375 6C12.4915 6 13.0251 6.51744 13.0251 7.15166ZM13.0251 15.4963V10.0445C13.0251 9.63033 12.6771 9.29289 12.25 9.29289H9.77507C9.34795 9.29289 9 9.63033 9 10.0445C9 10.4587 9.34795 10.7962 9.77507 10.7962H11.4749V15.4963H9.77507C9.34795 15.4963 9 15.8338 9 16.248C9 16.6622 9.34795 16.9996 9.77507 16.9996H12.25H14.7249C15.152 16.9996 15.5 16.6622 15.5 16.248C15.5 15.8338 15.152 15.4963 14.7249 15.4963H13.0251Z",
    fill: "white"
  }));
});